import { utilImages } from "../../Images";
import { useDarkMode } from "../Context/DarkModeContext";

export const useUtilImages = () => {
  const { dark } = useDarkMode();
  const { plus, plusDark, book, bookDark, cardBack, cardBackDark, down } =
    utilImages;

  const images = {
    plus: dark ? plusDark : plus,
    book: dark ? bookDark : book,
    cardBack: dark ? cardBackDark : cardBack,
    down,
  };

  return images;
};
